"use strict";
const DEFAULT_BASE_URL = "https://www.topazdex.com";
export const TOPAZ_STATS_API_ENABLED = (process.env.REACT_APP_TOPAZ_STATS_API_ENABLED ?? "true").toLowerCase() !== "false";
function getStatsApiBaseUrl() {
  const base = process.env.REACT_APP_UNISWAP_BASE_API_URL || DEFAULT_BASE_URL;
  return `${base.replace(/\/$/, "")}/api/stats`;
}
async function fetchStats(path) {
  const response = await fetch(`${getStatsApiBaseUrl()}${path}`, {
    method: "GET",
    headers: { Accept: "application/json" }
  });
  if (!response.ok) {
    throw new Error(`Topaz Stats API ${path} failed: HTTP ${response.status}`);
  }
  const envelope = await response.json();
  if (!envelope.ok) {
    const message = envelope.error?.message || "unknown error";
    throw new Error(`Topaz Stats API ${path} returned ok=false: ${message}`);
  }
  return envelope.data;
}
export async function fetchStatsPools() {
  return fetchStats("/pools?type=all&limit=500");
}
export async function fetchStatsGauges() {
  return fetchStats("/gauges");
}
export async function fetchStatsTokens() {
  return fetchStats("/tokens?limit=500");
}
export async function fetchStatsPool(poolAddress) {
  return fetchStats(`/pools/${poolAddress}`);
}
export async function fetchLiveDynamicFees() {
  return fetchStats("/live/dynamic-fees");
}
